import { useDisplayVariant } from 'modules/productDetail'
import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import ProductSlider from 'theme/molecules/ProductSlider'
import HighlightProduct from 'theme/molecules/HighlightProduct'
import fetchBySku from 'utils/productListFetcher/bySku'
import useTranslations from 'hooks/useTranslations'
import * as t from 'utils/productListFetcher/types'

export default function AlternativContainer(props: {
  btnLabel: string
  brandPath: string
}) {
  const variant = useDisplayVariant()
  const t = useTranslations<'templates-PDP'>()
  const { successions, alternatives } = variant.data.related
  const [products, setProducts] = React.useState<t.Product[]>([])
  const [title, setTitle] = React.useState<string>('')

  React.useEffect(() => {
    const getProducts = async () => {
      try {
        if (successions && successions.length > 0) {
          const result = await fetchBySku(successions)(0)
          if (result.data.length > 0) {
            setProducts(result.data)
            setTitle(t('pdp_successor_product'))
            return
          }
        }
        if (alternatives.length > 0) {
          const result = await fetchBySku(alternatives)(0)
          if (result.data.length > 0) {
            setProducts(result.data)
            if (result.data.length > 1) {
              setTitle(t('pdp_alternative_products'))
            } else {
              setTitle(t('pdp_alternative_product'))
            }
            return
          }
        }

        setProducts([])
      } catch (error) {
        setProducts([])
      }
    }
    getProducts()
  }, [successions, alternatives])

  if (products.length === 0) return null

  return (
    <Wrapper
      className="AlternativContainer"
      data-cy-collection="AlternativContainer"
    >
      <h2 className="title">{title}</h2>

      {products.length === 1 && (
        <HighlightProduct
          data-cy-state="show-alternativ-product"
          sku={''}
          brandPath={props.brandPath}
          btnLabel={props.btnLabel}
          product={{
            ...products[0],
            productReviews: products[0].productReviews || {}
          }}
        />
      )}

      {products.length > 1 && (
        <div
          data-cy-state="show-alternatives-slider"
          className="alternativ-container"
        >
          <ProductSlider
            maxProducts={products.length}
            initialProducts={products}
            fetchFn={() => new Promise(() => [])}
            listname={'product-alternative-slider'}
          />
        </div>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  padding: ${theme.spacing('l')} 0;
  > .title {
    margin-bottom: ${theme.spacing('m')};
    ${theme.ty('rc-2xl', null, 'rc-3xl')}
  }
`
